// Import model
import { UpdateLeadNoteRequest } from '../models/UpdateLeadNoteRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateLeadNoteRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateLeadNoteRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateLeadNoteRequest instance
   */
  static deserialize(json: string): UpdateLeadNoteRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateLeadNoteRequest instance
   */
  static fromObject(obj: any): UpdateLeadNoteRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateLeadNoteRequest');
    }


    const instance: UpdateLeadNoteRequest = {
      flowId: obj['flowId'] as string | undefined,
      objectStatusId: obj['objectStatusId'] as string | undefined,
      content: obj['content'] as string | undefined,
      description: obj['description'] as string | undefined,
      contentType: obj['contentType'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
      relatedObjects: obj['relatedObjects'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateLeadNoteRequest instances
   */
  static deserializeArray(json: string): UpdateLeadNoteRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateLeadNoteRequest instance to a JSON string
   */
  static serialize(instance: UpdateLeadNoteRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateLeadNoteRequest instance to a plain object
   */
  static toObject(instance: UpdateLeadNoteRequest): any {
    return {
      'flowId': instance.flowId,
      'objectStatusId': instance.objectStatusId,
      'content': instance.content,
      'description': instance.description,
      'contentType': instance.contentType,
      'isActive': instance.isActive,
      'relatedObjects': instance.relatedObjects,
    };
  }

  /**
   * Serializes an array of UpdateLeadNoteRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateLeadNoteRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
